import React, { useState, useEffect } from "react";
import {
  getWarehouses,
  addWarehouse,
  updateWarehouse,
  deleteWarehouse,
} from "../../services/apiService";
import "./AddWarehouse.css";
import { FaEdit, FaTrash, FaPlus, FaTimes } from "react-icons/fa";

export default function Warehouse() {
  const [warehouses, setWarehouses] = useState([]);
  const [filteredWarehouses, setFilteredWarehouses] = useState([]);
  const [warehouseForm, setWarehouseForm] = useState({
    warehouseName: "",
    warehouseAddress: "",
  });
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const fetchWarehouses = async () => {
    try {
      const data = await getWarehouses();
      setWarehouses(data);
      setFilteredWarehouses(data);
    } catch (err) {
      console.error("Fetch warehouses error:", err);
    }
  };

  useEffect(() => {
    const results = warehouses.filter((w) =>
      w.warehouseName?.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredWarehouses(results);
  }, [search, warehouses]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWarehouseForm((prev) => ({ ...prev, [name]: value }));
  };

  const openAddModal = () => {
    setWarehouseForm({
      warehouseName: "",
      warehouseAddress: "",
    });
    setEditId(null);
    setShowModal(true);
  };

  const handleEdit = (warehouse) => {
    setWarehouseForm({
      warehouseName: warehouse.warehouseName,
      warehouseAddress: warehouse.warehouseAddress,
    });
    setEditId(warehouse.warehouseId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setWarehouseForm({
      warehouseName: "",
      warehouseAddress: "",
    });
    setEditId(null);
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!warehouseForm.warehouseName || !warehouseForm.warehouseAddress) {
      alert("Please fill out all fields");
      return;
    }

    try {
      if (editId) {
        await updateWarehouse(editId, warehouseForm);
        alert("Warehouse updated successfully!");
      } else {
        await addWarehouse(warehouseForm);
        alert("Warehouse added successfully!");
      }

      handleCloseModal();
      fetchWarehouses();
    } catch (err) {
      console.error("Save warehouse error:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this warehouse?")) {
      try {
        await deleteWarehouse(id);
        alert("Warehouse deleted successfully!");
        fetchWarehouses();
      } catch (err) {
        console.error("Delete warehouse error:", err);
      }
    }
  };

  return (
    <div className="warehouse-container">
      <div className="warehouse-header">
        <h2>Warehouse Management</h2>
        <button className="add-warehouse-btn" onClick={openAddModal}>
          <FaPlus /> Add Warehouse
        </button>
      </div>

      <input
        type="text"
        placeholder="Search warehouses..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="warehouse-search"
      />

      <div className="warehouse-table-wrapper">
        <table className="warehouse-table">
          <thead>
            <tr>
              <th>Warehouse Name</th>
              <th>Warehouse Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredWarehouses.map((w) => (
              <tr key={w.warehouseId}>
                <td>{w.warehouseName}</td>
                <td>{w.warehouseAddress}</td>
                <td>
                  <button onClick={() => handleEdit(w)} className="edit-btn">
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDelete(w.warehouseId)}
                    className="delete-btn"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}

            {filteredWarehouses.length === 0 && (
              <tr>
                <td colSpan="3" className="no-data">
                  No warehouses found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="warehouse-modal-overlay">
          <div className="warehouse-modal">
            <div className="warehouse-modal-header">
              <h3>{editId ? "Edit Warehouse" : "Add Warehouse"}</h3>
              <button
                className="modal-close-btn"
                onClick={handleCloseModal}
                type="button"
              >
                <FaTimes />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="warehouse-form">
              <div className="form-group">
                <label>Warehouse Name</label>
                <input
                  type="text"
                  name="warehouseName"
                  placeholder="Enter warehouse name"
                  value={warehouseForm.warehouseName}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group full-width">
                <label>Warehouse Address</label>
                <input
                  type="text"
                  name="warehouseAddress"
                  placeholder="Enter warehouse address"
                  value={warehouseForm.warehouseAddress}
                  onChange={handleChange}
                />
              </div>

              <div className="form-buttons">
                <button type="submit" className="save-btn">
                  {editId ? "Update Warehouse" : "Save Warehouse"}
                </button>
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}